import { Component, input } from '@angular/core';
import { CurrencyPipe, NgClass } from '@angular/common';
import { AvaDividerComponent } from '../../ava-divider/ava-divider.component';
import { AvaSkeletonComponent } from '../../ava-skeleton';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { MembershipOfferSummary } from '../../../../store/price-offers/helpers/types';

@Component({
  standalone: true,
  selector: 'ava-offer-summary-cost',
  template: `
    @if (offers()) {
      @let offerPrimary = offers().primary || null;

      <div class="tw-flex tw-flex-col tw-gap-2">
        @if (offerPrimary) {
          <ava-divider />
        }

        @if (offerPrimary) {
          <div [ngClass]="offerPrimary.amount > 0 ? 'ava-fees' : 'ava-discounts'" class="tw-flex tw-justify-between">
            <div class="ava-text-sm" nz-tooltip [nzTooltipTitle]="offerPrimary.description">
              {{ offerPrimary.description }}
            </div>

            <div class="ava-text-sm">
              {{ offerPrimary.amount | currency }}

              @if (isMonthlyBilling() && !isLoading()) {
                <span>/mo</span>
              }
            </div>
          </div>
        }

        @for (optionalPrimary of offers().optionalPrimary; track optionalPrimary) {
          <div
            [ngClass]="
              optionalPrimary.amount <= 0 ||
              optionalPrimary.code === 'couponCode' ||
              optionalPrimary.code === 'promoCode'
                ? 'ava-discounts'
                : 'ava-fees'
            "
            class="tw-flex tw-justify-between"
          >
            <div class="ava-text-sm" nz-tooltip [nzTooltipTitle]="optionalPrimary.description">
              {{ optionalPrimary.description }}
            </div>

            <div class="ava-text-sm">
              {{ optionalPrimary.amount | currency }}
              @if (isMonthlyBilling() && !isLoading()) {
                <span>/mo</span>
              }
            </div>
          </div>
        }

        @for (optional of offers().optional; track optional) {
          <div [ngClass]="optional.amount > 0 ? 'ava-fees' : 'ava-discounts'" class="tw-flex tw-justify-between">
            <div class="ava-text-sm" nz-tooltip [nzTooltipTitle]="optional.description">{{ optional.description }}</div>
            <div class="ava-text-sm">
              {{ optional.amount | currency }}

              @if (isMonthlyBilling() && !isLoading()) {
                <span>/mo</span>
              }
            </div>
          </div>
        }

        @for (associate of offers().associates; track associate) {
          <div class="offer-summary-cost__associates tw-flex tw-flex-col tw-gap-2">
            @for (associateItem of associate.associate; track associateItem) {
              <div
                [ngClass]="
                  associateItem.amount < 0 || associateItem.code === 'couponCode' || associateItem.code === 'promoCode'
                    ? 'ava-discounts'
                    : 'ava-fees'
                "
                class="offer-summary-cost__associates--associate tw-flex tw-justify-between"
              >
                <div class="ava-text-sm" nz-tooltip [nzTooltipTitle]="associateItem.description">
                  {{ associateItem.description }}
                </div>
                <div class="ava-text-sm">
                  {{ associateItem.amount | currency }}

                  @if (isMonthlyBilling() && !isLoading()) {
                    <span>/mo</span>
                  }
                </div>
              </div>
            }

            @for (associateItemOptional of associate.associateOptional; track associateItemOptional) {
              <div
                [ngClass]="associateItemOptional.amount > 0 ? 'ava-fees' : 'ava-discounts'"
                class="offer-summary-cost__associates--associate-optional tw-flex tw-justify-between"
              >
                <div class="ava-text-sm" nz-tooltip [nzTooltipTitle]="associateItemOptional.description">
                  {{ associateItemOptional.description }}
                </div>
                <div class="ava-text-sm">
                  {{ associateItemOptional.amount | currency }}

                  @if (isMonthlyBilling() && !isLoading()) {
                    <span>/mo</span>
                  }
                </div>
              </div>
            }
          </div>
        }

        <ava-divider />

        <ava-skeleton size="small" [isLoading]="isLoading()">
          @if (totalCost() || allowZeroPrice()) {
            <div class="tw-flex tw-justify-between">
              <div class="ava-text-sm">Total</div>
              <div class="">
                <span class="tw-text-md tw-font-bold">
                  {{ totalCost() | currency }}
                </span>
                @if (isMonthlyBilling()) {
                  <span class="tw-text-sm">/mo</span>
                }
              </div>
            </div>
          }
        </ava-skeleton>
      </div>
    }
  `,
  styles: [
    `
      :host {
        .ava-discounts {
          color: green;
        }

        .offer-summary-cost {
          &__associates {
            margin-top: 0.7rem;

            &--associate,
            &--associate-optional {
              > div:first-child {
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
              }
            }
          }
        }
      }
    `,
  ],
  imports: [AvaSkeletonComponent, AvaDividerComponent, CurrencyPipe, NgClass, NzTooltipModule],
})
export class OfferSummaryCostComponent {
  isLoading = input(false);
  allowZeroPrice = input(false);
  totalCost = input(0);
  isMonthlyBilling = input(false);
  offers = input<MembershipOfferSummary>({
    primary: undefined,
    associates: [],
    optional: [],
    optionalPrimary: [],
  });
}
